var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStellar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Stellar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    "data-name": "Layer 2",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    "data-name": "Layer 1",
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_1",
    d: "m203,26.16l-28.46,14.5l-137.43,70a82.49,82.49 0 0 1 -0.7,-10.69a81.87,81.87 0 0 1 121.79,-71.37l16.29,-8.3l2.43,-1.24a100,100 0 0 0 -158.74,80.94q0,3.82 0.29,7.61a18.19,18.19 0 0 1 -9.88,17.58l-8.59,4.38l0,20.43l25.29,-12.89l0,0l8.19,-4.18l8.07,-4.11l0,0l144.88,-73.82l16.28,-8.29l33.65,-17.15l0,-20.42l-33.36,17.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_2",
    d: "m236.36,50l-186.58,95l-16.28,8.31l-33.5,17.07l0,20.41l33.27,-16.95l28.46,-14.5l137.57,-70.1a83.45,83.45 0 0 1 0.7,10.76a81.87,81.87 0 0 1 -121.91,71.36l-1,0.53l-17.66,9a100,100 0 0 0 158.75,-80.89c0,-2.57 -0.1,-5.14 -0.29,-7.68a18.2,18.2 0 0 1 9.87,-17.58l8.6,-4.38l0,-20.36z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_3",
    d: "m517.39,64.18c-28.54,0 -50.68,21 -50.68,54.17c0,30.87 18.25,54.56 51.26,54.56c25.44,0 42.13,-14.95 46.79,-32.82l-18.25,0c-4.46,10.29 -13,17.28 -28.54,17.28c-15.34,0 -31.65,-10.87 -32.23,-33.39l80.38,0c2.14,-33.2 -16.7,-59.8 -48.73,-59.8zm-31.46,44.65c1.56,-21 15.92,-29.51 31.46,-29.51c18.83,0 29.51,14.76 30.09,29.51l-61.55,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_4",
    d: "m359.26,89.61l-16.26,-3.69c-13.25,-2.92 -23,-9.12 -23,-21.55c0,-15.73 19,-20.58 29.9,-20.58c14,0 30.29,5.63 34.95,21.74l19.23,0c-5.64,-27 -28,-38.44 -53.4,-38.44c-22.72,0 -50.87,11.46 -50.87,38.44c0,23.3 19.22,34.18 38.64,38.45l17.55,3.69c17.67,4.08 30.29,9.9 30.29,24.85c0,14 -11.84,23.69 -32.81,23.69c-21.94,0 -35.14,-10.1 -38.83,-29.51l-19.46,0c3.69,28 24.66,46.21 57.86,46.21c28,0 53.59,-14.76 53.59,-42.14c0,-28.34 -25.82,-36.5 -47.38,-41.16z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_5",
    d: "m444.58,39.71l-17.67,0l0,26.21l-16.51,0l0,14.18l16.51,0l0,64.07c0,21.75 4.66,26.21 24.66,26.21l12.81,0l0,-14.75l-8.93,0c-10.1,0 -10.87,-2.72 -10.87,-13.59l0,-61.94l19.8,0l0,-14.18l-19.8,0l0,-26.21z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_6",
    d: "m794.69,65.34c-13.79,0.58 -24.27,7 -29.51,18.83l0,-18.25l-17.29,0l0,104.46l17.67,0l0,-54.75c0,-23.3 8.16,-32 24.47,-32a63.44,63.44 0 0 1 9.9,0.78l0,-18.88a52,52 0 0 0 -5.24,-0.19z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_7",
    d: "m730.89,131l0.19,-24.08c0.2,-29.71 -12.23,-43.1 -41.55,-43.1c-20.19,0 -40.39,12.62 -41.94,35.14l18.25,0c0.78,-13 9.13,-20.77 23.88,-20.77c13.21,0 23.69,6.21 23.69,25.43l0,2.52c-42.71,4.67 -70.67,12 -70.67,36.7c0,19.22 16.31,30.1 35.92,30.1c18.64,0 29.32,-6 35.72,-16.89a114.46,114.46 0 0 0 1.36,14.36l17.86,0c-2.13,-9.93 -2.91,-21.77 -2.71,-39.41zm-16.12,-4.27c0,24.65 -15.72,32.23 -32.23,32.23c-12.62,0 -20.19,-6.6 -20.19,-16.51c0,-14.37 20.38,-19.22 52.42,-22.33l0,6.61z"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_8",
    height: 140.84,
    width: 17.67,
    y: 29.54,
    x: 578.01
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_9",
    height: 140.84,
    width: 17.67,
    y: 29.54,
    x: 613.34
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStellar);
export default __webpack_public_path__ + "static/media/stellar.a8987631.svg";
export { ForwardRef as ReactComponent };